import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import axiosInstance from '../../axiosConfig';
import { useSecureAuth } from '../../contexts/SecureAuthContext';

function getLocalRedirectPath(redirectUrl, fallbackPath) {
  if (!redirectUrl) return fallbackPath || '/overview';

  try {
    const parsed = new URL(redirectUrl);
    if (parsed.origin === window.location.origin) {
      return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    }
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return fallbackPath || '/overview';
  }
}

export default function WhatsAppAssistantHandoff() {
  const { token } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, loading: authLoading } = useSecureAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    if (authLoading) return;

    const currentPath = `${location.pathname}${location.search}`;
    if (!isAuthenticated) {
      navigate(`/login?redirect=${encodeURIComponent(currentPath)}`, { replace: true });
      return;
    }

    let cancelled = false;

    async function resolveHandoff() {
      try {
        const response = await axiosInstance.get(
          `/revstar-whatsapp/assistant/handoff/${encodeURIComponent(token)}/resolve`,
        );
        if (cancelled) return;

        const target = getLocalRedirectPath(response.data?.redirectUrl, response.data?.targetPath);
        navigate(target, { replace: true });
      } catch (err) {
        if (cancelled) return;
        const message = err.response?.data?.error || 'This WhatsApp handoff link is invalid or expired.';
        setError(message);
      }
    }

    resolveHandoff();

    return () => {
      cancelled = true;
    };
  }, [authLoading, isAuthenticated, location.pathname, location.search, navigate, token]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24,
      background: '#f9fafb',
      color: '#111827',
      textAlign: 'center',
    }}>
      <div>
        <img src="/logo192.png" alt="Revstar" style={{ width: 44, height: 44, marginBottom: 16 }} />
        <h1 style={{ margin: '0 0 8px', fontSize: 20 }}>Opening Revstar</h1>
        <p style={{ margin: 0, color: '#6b7280', maxWidth: 360 }}>
          {error || 'Checking your secure WhatsApp handoff link...'}
        </p>
      </div>
    </div>
  );
}
